import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateTeams = () => {
  const searchedKey = getCacheKey('/teams');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
